import React, { Component } from "react";
import PropTypes from "prop-types";
import StatusFilter from "./StatusFilter";
import VehicleFilter from "./VehicleFilter";
import UserFilter from "./UserFilter";

class CalendarFilters extends Component {
  handleStatusChange = statuses => {
    this.props.onChange({ ...this.props.filters, statuses });
  };

  handleVehicleChange = vehicleId => {
    this.props.onChange({ ...this.props.filters, vehicleId });
  };

  handleUserChange = userId => {
    this.props.onChange({ ...this.props.filters, driverId: userId });
  };

  render() {
    const { filters } = this.props;

    return (
      <div className="query-filters">
        <div className="status-filter">
          <StatusFilter
            value={filters.statuses}
            onChange={this.handleStatusChange}
          />
        </div>

        <div className="vehicle-filter">
          <VehicleFilter
            value={filters.vehicleId}
            onChange={this.handleVehicleChange}
          />
        </div>

        <div className="user-filter">
          <UserFilter
            value={filters.driverId}
            onChange={this.handleUserChange}
          />
        </div>
      </div>
    );
  }
}
CalendarFilters.propTypes = {
  filters: PropTypes.shape({
    statuses: PropTypes.string,
    vehicleId: PropTypes.string,
    userId: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export default CalendarFilters;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/CalendarFilters.js